<div class="p-6 sm:p-8">
  @if (userId()) {
  <app-profile-management [userId]="userId()"
                          [readonlyMode]="careerProfileReadOnly()"></app-profile-management>
  } @else if (loadError()) {
  <p class="text-sm text-red-600">Kon je profiel niet laden.</p>
  } @else {
  <p class="text-sm text-gray-600">Je profiel wordt geladen...</p>
  }
</div>
